import { Model } from '@vuex-orm/core';

export class UserGroup extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'user_groups';

  static primaryKey = 'code';

  static fields() {
    return {
      name: this.attr(null),
      code: this.attr(null),
    };
  }
}

export default UserGroup;
